module.exports = new __parcel__URL__("sage-drawing.d02d922a.png").toString();